import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Activity, CreateActivityInput, UpdateActivityInput } from '@nx/domain';
import { asyncStatusReducers, initialAsyncStatus } from './asyncStatus';

export interface ActivitiesState {
  items: Activity[];
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: ActivitiesState = {
  items: [],
  ...initialAsyncStatus,
};

const activitiesSlice = createSlice({
  name: 'activities',
  initialState,
  reducers: {
    activitiesWatchRequested(_state, _action: PayloadAction<string>) {},
    activitiesLoaded(state, action: PayloadAction<Activity[]>) {
      state.items = action.payload;
      asyncStatusReducers.resolveLoaded(state);
    },
    activityCreateRequested(
      state,
      _action: PayloadAction<{ eventId: string; input: CreateActivityInput }>,
    ) {
      asyncStatusReducers.markSaving(state);
    },
    activityUpdateRequested(
      state,
      _action: PayloadAction<{
        eventId: string;
        activityId: string;
        input: UpdateActivityInput;
      }>,
    ) {
      asyncStatusReducers.markSaving(state);
    },
    activityDeleteRequested(
      _state,
      _action: PayloadAction<{ eventId: string; activityId: string }>,
    ) {},
    activityReorderRequested(
      _state,
      _action: PayloadAction<{ eventId: string; date: string; orderedIds: string[] }>,
    ) {},
    activitySaveSucceeded(state) {
      asyncStatusReducers.resolveSaveSucceeded(state);
    },
    activitiesFailed: asyncStatusReducers.resolveFailed,
  },
});

export const {
  activitiesWatchRequested,
  activitiesLoaded,
  activityCreateRequested,
  activityUpdateRequested,
  activityDeleteRequested,
  activityReorderRequested,
  activitySaveSucceeded,
  activitiesFailed,
} = activitiesSlice.actions;

export default activitiesSlice.reducer;
